import "../css/App.css";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./designSystem/Navbar";
import Footer from "./designSystem/Footer";
import ScrollToTop from "./designSystem/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import ContactUsComponent from "./components/ContactUsComponent";
import AboutUsPage from "./pages/AboutUs";
import MortgageCalculatorsPage from "./pages/MortgageCalculators";
import ServicesPage from "./pages/Services";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route
                path="/mortgage-calculators"
                element={<MortgageCalculatorsPage />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/our-services" element={<ServicesPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ContactUsComponent />
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
